import $ from 'jquery'

import form from './form/form'

export default function(o){

  var prevItem = null
  var prevModel = null

  var done = function(){
    o.edit.update()
    o.search.update()
  }

  var deleted = function(){
    div.empty()
    o.search.update()
  }

  var set = function(item,model){

    var modelName = model.getName()

    if(modelName != 'user/marker'){
      prevItem = item
      prevModel = model
    }

    if(o.store('role') == "admin" || o.store('role') == "author" || modelName == 'userMarker'){
      div
      .empty()
      .append(
        form(o,model,item,done,done,deleted)
      )
    }

  }

  var update = function(){
    if(prevItem){
      console.log(prevItem,prevModel);
      set(prevItem,prevModel)
    }
  }

  var div =
    $('<div>')
    .css({
      position: 'fixed',
      top: '402px',
      width: '400px',
      left: 0,
      bottom: 0,
    })

  div.set = set
  div.update = update

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/edit/edit.js